import { Select } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import FieldLabelGuide from "./fieldLabelGuide";
import NoMoreParentGuide from "./noMoreParentGuide";

export const PARENT_PAYEE_OPTIONS = [
  { value: "COMPANY", label: "Company" },
  { value: "UPLINE", label: "Upline" },
  { value: "TEAM_TOP", label: "Top Upline in the team" },
  { value: "PLAN_TOP", label: "Top Upline in the plan" },
];

const NoMoreParentToField = ({ value, onChange, label, disabled, readOnly }) => {
  const { t } = useTranslation();
  const [api] = useServerApi();
  const [info, setInfo] = useState({
    label: "Top Upline in the team",
    companyName: "",
  });

  useEffect(() => {
    let active = true;
    Promise.resolve(api.getParentPayeeDefault?.()).then((data) => {
      if (!active || !data) return;
      setInfo({
        label: data.label || "Top Upline in the team",
        companyName: data.companyName || "",
      });
    });
    return () => {
      active = false;
    };
  }, [api]);

  const selected = value ? value : "SYSTEM";
  const options = [
    {
      value: "SYSTEM",
      label: `${t("Use system default")} (${t(info.label)})`,
    },
    ...PARENT_PAYEE_OPTIONS.map((option) => ({
      ...option,
      label: t(option.label),
    })),
  ];

  return (
    <Select
      label={
        <FieldLabelGuide
          label={label || t("No more parent pays")}
          ariaLabel={t("When an upper level has no parent")}
          width={520}
        >
          <NoMoreParentGuide
            systemLabel={info.label}
            companyName={info.companyName}
          />
        </FieldLabelGuide>
      }
      data={options}
      value={selected}
      disabled={disabled || readOnly}
      onChange={(next) => onChange(!next || next === "SYSTEM" ? null : next)}
    />
  );
};

export default NoMoreParentToField;
